module.exports = __webpack_public_path__ + "img/1724297368050-kue-satu.webp.f04da3e5.webp";